import type { DraftContent } from '../types'
import { isObject } from './utils'

export const isDraft = (value: unknown): value is DraftContent =>
  isObject(value) && Array.isArray(value.blocks)
